<script>

import config from '../../common/genericPanelConf';
import Service from '../../services/stock-management';
import CommonService from '../../services/common';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import {FilterMatchMode} from 'primevue/api';

import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable, ResponsiveButton
        ,GenericBooleanDropdown, GenericCustomMasterDataAutocompleteV2, GenericCustomAutocompleteV2
    },
    data(){
        return{
            configuration: {},
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(),-1),
            },
            twentyFour: '24.00',
            addManualVisible: false,
            editItem: {}
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        load(){
            let filters = [
                {
                    operator: 'eq',
                    value: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                    property: 'ReferenceDate'
                },
                {
                    operator: 'eq',
                    value: 'Daily',
                    property: 'Type'
                }
            ]
            this.$refs.dailyPipeGrid.filterFromView(filters, false);
        },
        onDialogEditSave(newItem, oldItem){
            this.$store.dispatch("generic/setLoading", true);
            // UPDATE
            CommonService.updateItem(this.configuration.api, newItem, response => {
                this.disabled = false;
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$refs.dailyPipeGrid.hideDialogEdit();
                    this.load();
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            }, this.configuration.idColumn)
        },
        reimport(){
            this.$confirm.require({
                message:  this.$t('StockManagementDailyPipe.reimportMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    Service.dailyPipeCreateNewDay(response => {
                        if(response.success){
                            this.$toast.add({detail: this.$t('StockManagementDailyPipe.reimportSuccess'), life:3000, severity:'success'});
                            this.load();
                        }
                        else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    });
                },
                reject: () => {
                    
                }
            });
        },
        showAddManual(visible){
            if(visible){
                this.editItem = {
                    referenceDate : this.filters.referenceDate,
                    type: 'Daily'
                };
            }
            this.addManualVisible = visible
        },
        onAddManual(){
            this.editItem.referenceDate =  Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))
            for(const key in this.editItem){
                if(key + 'Source' in this.editItem){
                    this.editItem[key + 'Source'] = 'Manual';
                }
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.createStockManagementDailyPipe(this.editItem, (response) => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.showAddManual(false);
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })

        },
        onStockManagementPipeDelete(data){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    CommonService.deleteItem(this.configuration.api, data.id, response => {
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.load();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        }
    },
    computed: {
        conf(){
            return config;
        },
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        fieldsForDialogEdit(){
            let fields =  [];

            if(this.configuration && this.configuration.columns){
                fields = this.configuration.columns.filter(col => col.inLineEdit)
            }
            return fields;
        },
    }
}
</script>



<template>
    <!-- EDIT MODE DIALOG -->
        <Dialog v-model:visible="addManualVisible" :style="{width: '85vw'}" :modal="true" >
            <div class="grid">
                <div class="col-12 lg:col-4" v-for="field in fieldsForDialogEdit" :key="field.name">
                    <label :for="field.name">{{$t(field.label)}}</label>
                    <InputText 
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'string'" 
                        class="w-full"
                        v-model="editItem[field.name]" />
                    <InputNumber 
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        mod="number" 
                        v-if="field.type == 'number'"
                        v-model="editItem[field.name]" />
                    <InputNumber
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        mode="decimal" :maxFractionDigits="field.digits" :minFractionDigits="field.digits"
                        v-if="field.type == 'decimal'"
                        v-model="editItem[field.name]" />
                    <Calendar 
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        v-if="field.type == 'date'"    
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="field.onlyDate ? false : true"
                        v-model="editItem[field.name]" />
                    <GenericBooleanDropdown
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'boolean'"
                        v-model="editItem[field.name]" 
                        class="w-full" />
                    <GenericCustomMasterDataAutocompleteV2
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'select'"
                        :name="field.name"
                        v-model="editItem[field.updateField ?? field.name]" 
                        :api="field.selectApi"
                        :format="field.selectFormat" />
                    <GenericCustomAutocompleteV2
                        class="w-full"
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        v-if="field.type == 'select-simple'"
                        :name="field.name"
                        v-model="editItem[field.updateField ?? field.name]" 
                        :api="field.selectApi"
                        :format="field.selectFormat" />
                    <Textarea
                        :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                        class="w-full" 
                        v-if="field.type == 'textarea'"
                        v-model="editItem[field.name]" />
                </div>
            </div>
                <template #footer>
                    <Button :label="$t('btn.save')" icon="pi pi-save" @click="onAddManual" autofocus />
                </template>
        </Dialog>
    <div class="grid">
        <div class="col-8 lg:col-2 field">
            <label for="referenceDate">{{$t('StockManagementDailyTank.referenceDate')}}</label>
            <Calendar
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-2 lg:col-1 field">
            <label>{{$t('at')}}</label>
            <InputText readOnly v-model="twentyFour" class="w-full " />
        </div>
        <div class="col-12 lg:col-7">
            <div class="p-3">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="load"/>   
                <ResponsiveButton :label="$t('btn.reimport')" icon="pi pi-download" class="mx-1 my-1" @click="reimport" :disabled="!uiPermissions('stockManagementDailyPipeCreateNewDayButton').isEnabled || !utils.isToday(utils.formatDatePlusDays(this.filters.referenceDate, 1))"/>   
            </div>
        </div>
        <div class="col-12" style="height: calc(100vh - 210px)">
            <!-- <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="mx-1 my-1" @click="showAddManual(true)" :disabled="!uiPermissions('stockManagementDailyPipeCreateNewDayButton').isEnabled"/>   -->
            <GenericDataTable ref="dailyPipeGrid" :configuration="configuration" :category="category" :name="name" :onDialogEditSave="onDialogEditSave" @on-stock-management-pipe-delete="onStockManagementPipeDelete"/>
        </div>
    </div>
</template>